// extracted by mini-css-extract-plugin
export default {"skill":"style_skill__kSMTM","skillNum":"style_skillNum__QlM8B","text":"style_text__ZGG1f","addSkill":"style_addSkill__R0Jw4"};